import { memo } from 'react';

import { PostOrPage } from '@tryghost/content-api';

import DateBox from 'components/DateBox';
import Link from 'components/Link';

import { BLOGPOST_URL } from 'lib/urls';

import * as S from './styles';

interface IBlogPostBox {
  blogPost: PostOrPage;
  className?: string;
}

const BlogPostBox = ({ blogPost, className }: IBlogPostBox) => {
  const blogPostUrl = BLOGPOST_URL({ slug: blogPost.slug });

  return (
    <S.BlogPostBox className={className}>
      {blogPost.feature_image && (
        <Link href={blogPostUrl}>
          <S.StyledImage src={blogPost.feature_image} width={600} height={300} />
        </Link>
      )}
      <S.Content>
        <S.Category>{blogPost.primary_tag?.name}</S.Category>
        <S.Title>
          <Link href={blogPostUrl}>{blogPost.title}</Link>
        </S.Title>
        <S.Split>
          <S.Author>by {blogPost.primary_author?.name}</S.Author>
          {blogPost.published_at && <DateBox date={blogPost.published_at} showDay />}
        </S.Split>
        <S.Description>{blogPost.custom_excerpt}</S.Description>
      </S.Content>
    </S.BlogPostBox>
  );
};

export default memo(
  BlogPostBox,
  (prevProps, nextProps) => prevProps.blogPost.slug === nextProps.blogPost.slug
);
